import IcBin from './IcBin'
export default IcBin
